// -------------------------------------------------------------------------
window.__nav = {}
window.timeDelay = 0;
window.__navigation = (infor = {element: '', tabs: ''},flag = false, activeMenu) => {
    let $key = infor.key || Math.random().toString(36).substring(2);
    if(!infor.active) infor.active = {key: null, immediate: false};
    if(!infor.rendered) infor.rendered = ()=>{ return true};
    __nav[$key] = {
        ...infor,
        update: (data)=> { return update(data)},
        def: (data)=>{ return __navigation(data)}
    };
    
    let n = infor.tabs.length;
    function render_tabs(tabs, dropdown = false){
        function data_set(data){
            if(!data) return '';
            let html = ``
            Object.keys(data).forEach((key)=>{
                html += `data-${key}="${data[key]}" `;
            })
            return html
        }
        let display = ``;
        let tabs_html = ``;
        for(let i = 0; i < n; i++){
            if(!activeMenu.includes(tabs[i].menuName) && tabs[i].menuName!==undefined) display = 'hide';
            else if(tabs[i].key==='favorites') display = 'show';
            else display = '';
            tabs_html += `
                <li class="m-tabs-controls__item ${dropdown ? 'dropdown-item-menusection' : ''} ${display}">
                    <div class="m-tabs-controls__link" data-id="${i}" data-key="${tabs[i].key || '0'}" ${data_set(tabs[i].data)}>
                        <div class="m-tab__title">${tabs[i].title || ''}</div>
                        <div class="m-tabs__sub-title">${tabs[i].sub_title || ''}</div>
                    </div>
                </li>
            `;
            // if(dropdown) tabs_html += `<div class="dropdown-divider"></div>`;
        }
        return tabs_html;
    }

    let html = `
        <div class="d-flex w-100 m-tabs" data-key="${$key}" style="background-color: white;">
            <div id="m-tabs-${$key}" class="m-navigation">
                <ul class="m-tabs-controls">
                    ${render_tabs(infor.tabs)}
                </ul>
            </div>
            <div class="dropdown dropleft" style="max-height: 60vh; background-color: white; margin:auto; margin-right:0px;">
                <a style="cursor: pointer" class="dropdown-toggle text-black fix_size_more" id="dropdown-menu-${$key}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    More...
                </a>
                <ul class="dropdown-menu" aria-labelledby="dropdown-menu-${$key}" style="max-height: 60vh; min-width: 250px; overflow: auto">
                    ${render_tabs(infor.tabs, true)}
                </ul>
            </div>
        </div>
    `;
    $(infor.element).find(`#m-tabs-${$key}`).parent().remove();
    $(infor.element).append($(html));
    rerender_navbar()
    let $this = $(`#m-tabs-${$key}`);
    //  add style and class
    if(infor.style) $this.parent().css(infor.style);
    if(infor.class){
        infor.class.forEach((item)=>{
            $this.addClass(item);
        })
    }

    // add data 
    if(infor.data){
        Object.keys(infor.data).forEach((key)=>{
            $this.data(`${key}`, infor.data[key]);
        })
    }

    //  add active item and run
    let active_item = __nav[$key].active.key;
    let active_immediatly = __nav[$key].active.immediate;
    let elem;
    if(!active_item){
        elem = $this.find('.m-tabs-controls__link').first();
    }else{
        elem = $this.find(`.m-tabs-controls__link[data-key="${active_item}"]`);
    }
    elem.addClass('m-tabs-controls__link--active')
    if(active_immediatly) {
        $(document).ready(function(){
            let id = elem.data('id');
            infor.tabs[id].func();
        })
    }
    // Active event
    $this.parent().find('.m-tabs-controls__link').on('click', function(e) {
        e.preventDefault();
        __nav[$key].active.key = $(this).data('key');
        let id = $(this).data('id');
        $(`.menu-section-collapse`).show()
        if ($(this).hasClass('m-tabs-controls__link--active')) return false;
		$this.parent().find('.m-tabs-controls__link--active').removeClass('m-tabs-controls__link--active');
        $(this).addClass('m-tabs-controls__link--active');
        infor.tabs[id].func();

        $(window).on('resize scroll').unbind();
        clearTimeout(resetTime);
        setTimeCallEvent();
        timeDelay = 2000;
    });
    // Rendered
    $(document).ready(function(){
        infor.rendered();
    })
}

var resetTime;
function setTimeCallEvent() {
    resetTime = setTimeout(function(){callEventActiveMenu(); }, 3000);
}

function update(infor){
    let key = infor.key;
    let def = __nav[key].def;
    __nav[key] = {
        active: __nav[key].active,
        ...infor,
    }
    return def(__nav[key]);
}

// $(window).scroll(function(){ rerender_navbar() })

window.rerender_navbar = () => {
    $('.m-tabs').each(function(index, m_tab){
        let NAV_ELEMs = $(m_tab).find('.m-navigation').find('.m-tabs-controls__item')
        let MENU_ELEMs = $(m_tab).find('.dropdown-item-menusection')
        let i = 0;
        let j = 0;
        let n = NAV_ELEMs.length
        let parent_width = $(m_tab).width();
        let items_width = 0;
        let screen_width = parent_width - 100
        while (i < n){
            let w =  $(NAV_ELEMs[i]).width()
            if( items_width + w > screen_width){
                $(m_tab).find('.number-items').html(`(${n-i})`)
                for(j=i; j<n; j++){
                    $(MENU_ELEMs[j]).show()
                    $(NAV_ELEMs[j]).hide()
                }
                break;
            }else{
                $(NAV_ELEMs[i]).show()
                $(MENU_ELEMs[i]).hide()
                items_width += w
                i++
            }
        }
        if(j){
            $(m_tab).find('.dropdown').show()
        }else{
            $(m_tab).find('.dropdown').hide()
        }
    })    
}

$(window).on('resize', function(){
    rerender_navbar()
})


// ==============================================================================================
// ==============================================================================================
// ==============================================================================================

  $.fn.isInViewportMenu= function() {
      let windowPath = window.location.href
      if (!windowPath.includes("free-food-at-restaurant")) {
          var elementTop = $(this).offset().top;
          var elementBottom = elementTop + $(this).outerHeight();
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();
          return elementBottom > viewportTop && elementTop < viewportBottom;
      }    
  };
window.callEventActiveMenu = () =>{
    $(window).on('resize scroll', function() {
        setTimeout(function() {
            timeDelay = 200;
            if($('#favorites-menu-items').isInViewportMenu()){
                $('.m-tabs-controls').find('.m-tabs-controls__link--active').removeClass('m-tabs-controls__link--active');
                $('.dropdown-menu').find('.m-tabs-controls__link--active').removeClass('m-tabs-controls__link--active');
                $('.m-tabs-controls').find('.m-tabs-controls__item ').find('div[data-key="favorites"]').addClass('m-tabs-controls__link--active');
            }
            $('.menu-section').each(function() {
                var key = $(this).find('.menusubheading').attr('id');
                if ($(this).isInViewportMenu()) {
                    key = key.replace("menusection_","");

                    if($('.m-tabs-controls').find('.m-tabs-controls__item ').find('div[data-key="'+key+'"]').length>0){
                        $('.m-tabs-controls').find('.m-tabs-controls__link--active').removeClass('m-tabs-controls__link--active');
                        $('.m-tabs-controls').find('.m-tabs-controls__item ').find('div[data-key="'+key+'"]').addClass('m-tabs-controls__link--active');
                        
                        if($('.m-tabs-controls').find('.m-tabs-controls__item').find('.m-tabs-controls__link--active').is(":hidden")){
                            $('.fix_size_more').addClass('m-tabs-controls__link--active');
                        }else{
                            $('.fix_size_more').removeClass('m-tabs-controls__link--active');
                        }
                        $('.dropdown-menu').find('.m-tabs-controls__link--active').removeClass('m-tabs-controls__link--active');
                        $('.dropdown-menu').find('.m-tabs-controls__item ').find('div[data-key="'+key+'"]').addClass('m-tabs-controls__link--active');
                    }
                }
            });
        },timeDelay)
    });
}
callEventActiveMenu();

$(window).on('scroll', function() {
    rerender_navbar()
});
